import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../../api/api';
import { commonMoodlePayload } from '../../config';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { METHODS, SERVICES } from '../../api/constants';
import { feedbackWidgetApiCallLimit } from '../../components/FeedbackWidget/constant';

export const fetchFeedbacks = createAsyncThunk(
  'appFeedbackWidget/fetchFeedbacks',
  async (param) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        { ...param, ...commonMoodlePayload }
      );
      return { data: response.data };
    } catch (e) {}
  }
);
export const fetchFeedbackWidgetQuestionsData = createAsyncThunk(
  'appFeedbackWidget/fetchFeedbackWidgetQuestionsData',
  async (param) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        { ...param, ...commonMoodlePayload }
      );
      return { data: response.data };
    } catch (e) {}
  }
);
export const postFeedbacks = createAsyncThunk(
  'appFeedbackWidget/postFeedbacks',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.POST,
        { ...param, ...commonMoodlePayload }
      );
      if (response?.data?.completed) {
        thunkApi.dispatch(
          fetchFeedbacks({
            wsfunction: MOODLE_BACKEND_ROUTES.GET_FEEDBACK_WIDGET_FEEDBACKS,
            wstoken: param.wstoken,
            limit:
              feedbackWidgetApiCallLimit.feedbackWidgetApiCallLimitOfFeedbacksSuggestion
          })
        );
      }
      return { data: response.data };
    } catch (e) {}
  }
);

export const feedbackWidgetSlice = createSlice({
  name: 'feedbackWidgetSlice',
  initialState: {
    loading: false,
    success: false,
    feedbacksData: null,
    questionsData: null,
    hasFeedback: false
  },
  reducers: {
    updateSuccessState: (state, action) => {
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFeedbacks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchFeedbacks.fulfilled, (state, action) => {
      state.loading = false;
      state.feedbacksData = action.payload?.data?.feedbacks;
      if (action.payload?.data?.feedbacks?.length) {
        state.hasFeedback = true;
      }
      if (action.meta.arg.limit == 2) {
        state.success = true;
      } else {
        state.success = false;
      }
    });
    builder.addCase(fetchFeedbacks.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(fetchFeedbackWidgetQuestionsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchFeedbackWidgetQuestionsData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.questionsData = action.payload?.data?.items;
      }
    );
    builder.addCase(fetchFeedbackWidgetQuestionsData.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(postFeedbacks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postFeedbacks.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(postFeedbacks.rejected, (state) => {
      state.loading = false;
    });
  }
});
export const { updateSuccessState } = feedbackWidgetSlice.actions;
export default feedbackWidgetSlice.reducer;
